import ROUTE_PATHS from './routePaths';

export const createRoute = data => {
  const { referral, patientId, kardiaRxEcg, idtf_connection_id } = data;
  let patientFileRoute = `${ROUTE_PATHS.PATIENTS_PATIENT_FILE}/${patientId}`;
  if (referral) {
    patientFileRoute = `${patientFileRoute}?referral=patientSearch`;
  } else if (kardiaRxEcg) {
    patientFileRoute = `${patientFileRoute}?referral=kardiaRxEcg&idtf_connection_id=${idtf_connection_id}`;
  }
  return patientFileRoute;
};



// WEBPACK FOOTER //
// ./src/routes/patientRouteUtils.js